function getSummaryStatistics(items) {
  const summaryStatistics = {
    published: 0,
    new: 0,
    uniqueCreators: 0,
  };

  if (!items) {
    return summaryStatistics;
  }

  const uniqueCreators = new Set();

  items.forEach((item) => {
    if (item.status === 'published') {
      summaryStatistics.published += 1;
    } else if (item.status === 'new') {
      summaryStatistics.new += 1;
    }
    
    uniqueCreators.add(item.creatorName);
  });

  return {
    ...summaryStatistics,
    uniqueCreators: uniqueCreators.size,
  };
}

export {
  getSummaryStatistics,
};